import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DashboardTrafficMobile  from "./pages/DashboardTrafficMobile";
import HomeRedirect  from "./pages/HomeRedirect";
import StokNasional  from "./pages/StokNasional";
import DashboardMobile from "./pages/DashboarMobile";
import DashboardTraffic from "./pages/DashboardTraffic";
import CrewSetting from "./pages/Crew";
import StockCard from "./pages/StockCard";
import PickPackReport from "./pages/PickPackReport";
import MarketingPlan from "./pages/MarketingPlan";
import ReceiveDirect from "./pages/ReceiveDirect";
import MarketingHq from "./pages/MarketingHq";
import MobileLayout from "./layout/MobileLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import GoogleAuthSetup from "./pages/2fa-setup";
import OrderProductReq from "./pages/OrderProductRequest";
import AppLayout from "./layout/AppLayout";
import DailyReportSales from "./pages/PenjualanHarian";
import ValidasiPembayaran from "./pages/ValidasiPembayaran";
import TiktokShopOrder from "./pages/OrderTiktok";
import WebstoreOrder from "./pages/OrderWebstore";
import TiktokFinance from "./pages/TiktokshopFinance";
import CancelOrder from "./pages/CancelOrder";
import SjMasuk from "./pages/SjMasuk";
import SjMasukLaporan from "./pages/SjMasukLaporan";
import MutasiMasukLaporan from "./pages/MutasiMasukLaporan";
import MutasiMasuk from "./pages/MutasiMasuk";
import PerintahMutasiMd from "./pages/InstruksiMutasiMd";
import PerintahRetusPromosi from "./pages/InstruksiReturPromosi";
import PerintahReturWhs from "./pages/InstruksiReturWhs";
import MutasiKeluarLaporan from "./pages/MutasiKeluarReport";
import SurveyLandingPage from "./pages/SurveyLandingPage";
import SessionLoginModal from "./components/SessionLoginModal";
import TiktokShopFinanceGlobal from "./pages/TiktokShopFinanceGlobal";
import { registerSessionModal } from "./utils/apiFetch"; // nanti kita buat
import { useState, useEffect } from "react";
export default function App() {
   const [showSessionModal, setShowSessionModal] = useState(false);
  const Dummy = ({ title }) => <div>{title}</div>;
  useEffect(() => {
  registerSessionModal(() => {
    setShowSessionModal(true);
  });
}, []);
  return (
    
    <BrowserRouter>
      <Routes>
        

        {/* PUBLIC */}
        <Route path="/login" element={<Login />} />
        <Route path="/2fa-setup" element={<GoogleAuthSetup />} />
        {/* <Route path="/form-marketing" element={<MarketingForm />} /> */}
        <Route path="/survey/:kode_toko" element={<SurveyLandingPage />} />
        
<Route path="/finance/tiktok-finance-offline" element={<TiktokShopFinanceGlobal />} />
        {/* PROTECTED WRAPPER */}
        <Route element={<ProtectedRoute />}>
          
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/dashboard" element={<Dashboard />} />


            <Route element={<MobileLayout />}>
  <Route path="/m-home" element={<DashboardMobile />} />
  <Route path="/m-analytics" element={<DashboardTrafficMobile />} />
  <Route path="/m-sales" element={<Dummy title="Sales" />} />
  <Route path="/m-profile"  element={<Dummy title="Profile" />} />
</Route>

            <Route path="/traffic" element={<DashboardTraffic />} />
            <Route path="/sales/daily-report" element={<DailyReportSales />} />
            <Route path="/tiktokshop/orders" element={<TiktokShopOrder />} />
            <Route path="/tiktokshop/pickpack-order-report" element={<PickPackReport />} />
             <Route path="/webstore/orders" element={<WebstoreOrder />} />
             <Route path="/marketing/marketing-hq" element={<MarketingHq />} />
             
  <Route path="/finance/validate-payment" element={<ValidasiPembayaran />} />
              <Route path="/inventory/stock-card" element={<StockCard />} />
               <Route path="/warehouse/sj-masuk-laporan" element={<SjMasukLaporan />} />
                <Route path="/warehouse/mutasi-masuk-laporan" element={<MutasiMasukLaporan />} />
                <Route path="/warehouse/mutasi-keluar-laporan" element={<MutasiKeluarLaporan />} />
                <Route path="/warehouse/mutasi-masuk" element={<MutasiMasuk />} />
                <Route path="/warehouse/perintah-mutasi" element={<PerintahMutasiMd />} />
                <Route path="/warehouse/receive-direct" element={<ReceiveDirect />} />
                <Route path="/finance/tiktok-finance" element={<TiktokFinance />} />
                <Route path="/warehouse/surat-jalan-masuk" element={<SjMasuk />} />
                 <Route path="/inventory/national-stock" element={<StokNasional />} />
                <Route path="/warehouse/retur-promosi" element={<PerintahRetusPromosi />} />
                <Route path="/marketing/marketing-plan" element={<MarketingPlan />} />
                <Route path="/warehouse/retur-center" element={<PerintahReturWhs />} />
                <Route path="/warehouse/sales-order-req" element={<OrderProductReq />} />
                <Route path="/tiktokshop/cancel-orders" element={<CancelOrder />} />
                <Route path="/setting/crew" element={<CrewSetting />} />
          </Route>

        </Route>

      </Routes>

       {/* ✅ MODAL HARUS DI DALAM RETURN */}
      <SessionLoginModal
        open={showSessionModal}
        onClose={() => setShowSessionModal(false)}
        onSuccess={() => {
          setShowSessionModal(false);
        }}
      />

    </BrowserRouter>

    
  );

 
}